type NormalizeOptions = {
	currencySymbol?: string;
	fallback?: string;
};

const DEFAULT_FALLBACK = 'Unknown error';

const errorMatchers: Array<{
	match: string;
	getMessage: (symbol?: string) => string;
}> = [
	{
		match: 'InsufficientCoinBalance',
		getMessage: (symbol?: string) => `Not enough ${symbol ?? 'funds'} on your account.`,
	},
	{
		match: 'Insufficient gas budget',
		getMessage: () => 'Transaction failed due to insufficient gas. Please try again.',
	},
	{
		match: 'Insufficient gas',
		getMessage: () => 'Not enough gas to complete the transaction.',
	},
	{
		match: 'Rejected from user',
		getMessage: () => 'Transaction was rejected by the user.',
	},
	{
		match: 'Transaction expired',
		getMessage: () => 'Transaction expired. Please try again.',
	},
];

const toMessage = (raw: unknown): string => {
	if (typeof raw === 'string') return raw;
	if (raw instanceof Error) return raw.message;
	return String(raw ?? '');
};

export const normalizeSuiErrorMessage = (rawError: unknown, options: NormalizeOptions = {}) => {
	const { currencySymbol, fallback = DEFAULT_FALLBACK } = options;
	const rawMessage = toMessage(rawError) || fallback;

	const matcher = errorMatchers.find(({ match }) => rawMessage.includes(match));
	if (matcher) {
		return matcher.getMessage(currencySymbol);
	}

	return rawMessage || fallback;
};

export const isSignatureInvalidError = (rawError: unknown) => {
	const message = toMessage(rawError).toLowerCase();
	return message.includes('signature is not valid');
};
